import React, { useContext, useEffect, useReducer, useState } from 'react'
import { storage } from '../storage'
import { AppActionType, appInitialState, appReducer, IAppAction, IAppState } from './AppReducer'

interface IAppContext {
  state: IAppState
  dispatch: React.Dispatch<IAppAction>
}

const AppContext = React.createContext<IAppContext | null>(null)

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('useAppContext must be used within AppContextProvider')
  }
  return context
}

export interface AppContextProviderProps {
  children: React.ReactNode
}

export function AppContextProvider({ children }: AppContextProviderProps) {
  const [stateLoaded, setStateLoaded] = useState(false)
  const [state, dispatch] = useReducer(appReducer, appInitialState)

  useEffect(() => {
    if (stateLoaded) {
      storage.set(state)
      return
    }

    const storageState = storage.get()
    if (storageState) {
      dispatch({ type: AppActionType.InitState, data: storageState })
    }
    setStateLoaded(true)
  }, [stateLoaded, state])

  return (
    <AppContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
